<template>
  <v-dialog v-model="dialog" width="720">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mr-2" v-on="on">
        <v-icon color="#424242">mdi-information-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="modalTitle">Editar Administrador</span>
        <v-btn icon text @click="dialog = false">
          <Icon icon="mdi-close" color="#9E9E9E" size="24" style="cursor: pointer;" />
        </v-btn>
      </v-card-title>
      <v-card-text style="background: #F5F5F5;">
        <v-container>
          <v-row>
            <v-col sm="6">
              <span class="inputLabel">Nome:</span>
              <v-text-field
                single-line
                solo
                flat
                class="inputTextfield"
                @input="updateField('name', $event)"
                :value="name"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <span class="inputLabel">Telefone:</span>
              <v-text-field
                single-line
                solo
                flat
                class="inputTextfield"
                @input="updateField('phone', $event)"
                :value="phone"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <span class="inputLabel">Email:</span>
              <v-text-field
                single-line
                solo
                flat
                class="inputTextfield"
                @input="updateField('email', $event)"
                :value="email"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-col sm="12" class="d-flex align-center justify-space-between">
          <v-btn class="modalButton" text @click="dialog = false">
            <span class="buttonTextBlue">Cancelar</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="modalButton" color="#0012A6" @click="updateAdmin()">
            <span class="buttonTextWhite">Confirmar</span>
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import Icon from "@/components/atoms/icon";
export default {
  components: {
    Icon
  },
  data() {
    return {
      dialog: false,
      locals: [],
      areas: [],
      fields: {
        name: "",
        email: "",
        phone: ""
      }
    };
  },
  methods: {
    remove(item) {
      this.locals.splice(this.locals.indexOf(item), 1);
      this.locals = [...this.locals];
    },
    updateField(item, value) {
      this.fields[item] = value;
    },
    updatePropValues() {
      this.$emit(`update:name`, this.fields.name);
      this.$emit(`update:email`, this.fields.email);
      this.$emit(`update:phone`, this.fields.phone);
    },
    updateAdmin() {
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/admin/update`,
          {
            _id: this.id,
            name: this.fields.name || this.name,
            email: this.fields.email || this.email,
            phone: this.fields.phone || this.phone
          },
          {
            headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
          }
        )
        .then(() => {
          axios
            .get(`${process.env.VUE_APP_API_URL}/api/admin/webapp`, {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            })
            .then(res => {
              this.updatePropValues();
              this.dialog = false;
              this.$store.dispatch("setAccounts", {
                accounts: res.data.data.users
              });
            });
        })
        .catch(err => console.log(err));
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    phone: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

<style scoped>
.modalTitle {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}

.inputLabel {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}

.inputTextfield {
  height: 48px;
  width: 316px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}

.modalButton {
  height: 40px;
  width: 203px;
  border-radius: 5px;
  box-sizing: border-box;
}

.buttonTextBlue {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
}

.buttonTextWhite {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #fff;
}
</style>